import { Trans, useTranslation } from "next-i18next";
import { FC } from "react";
import Image from "next/image";
import styles from "./MediaKitHero.module.scss";

// import HeroBG from "@cs/public/img/about-page-img/about-hero.png";
import NewsPaperEarthly from "@cs/public/img/media-kit/newspaper-earthly.png";
import { NextSeo } from "next-seo";

const MediaKitHero: FC = () => {
  const {t} = useTranslation('media-kit')

  return (
    <section className={styles.outerHero}>
      <NextSeo 
        title={t('media-kit')}
      />
      <div className={styles.innerHero}>
        <div className={styles.heroTitles}>
          <h1 className={styles.title}>{t('press-media')}</h1>
          <p className={styles.text}>
            <Trans 
              t={t}
              i18nKey='tell-story'
            />
          </p>
        </div>
        <div className={styles.olympiadImageContainer}>
          <Image
            alt="Earthly learning and teaching" 
            src={NewsPaperEarthly}
            layout="responsive"
          />
        </div>
      </div>
    </section>
  )
}

export default MediaKitHero